<template>
    <div :class="['w-full flex', toolTip ? 'flex-row' : 'flex-col', $attrs.class]">
        <CoreCheckbox
            v-bind="$attrs"
            class="flex items-center cursor-pointer"
            label-classes="cursor-pointer block text-gray-900 dark:text-gray-200 text-sm leading-6 ml-3 select-none peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"
            input-classes="cursor-pointer h-4 w-4 rounded-sm border-gray-300 text-primary focus:ring-primary peer disabled:opacity-50 disabled:cursor-not-allowed"
            input-invalid-classes="border-red-600"
            error-classes="mt-1 text-sm text-red-600">
            <template
                v-for="(_, slot) in $slots"
                #[slot]="scope">
                <slot
                    :name="slot"
                    v-bind="{...scope}" />
            </template>
        </CoreCheckbox>
        <div
            v-if="toolTip"
            class="flex self-end items-center pl-1 shrink">
            <BasePopover
                size="sm"
                :position="toolTip === true ? 'bottom-left' : toolTip">
                <template #trigger>
                    <Icon
                        v-if="toolTip"
                        name="question-mark-circle"
                        size="5"
                        class="my-2 text-primary-500 hover:bg-primary-500 hover:text-white hover:rounded-full" />
                </template>
                <template #default>
                    <span class="text-neutral-500 dark:text-gray-300">
                        {{ description }}
                    </span>
                </template>
            </BasePopover>
        </div>
        <div
            v-if="!toolTip"
            class="text-sm mt-1">
            <span
                v-if="description"
                class="text-neutral-500 dark:text-gray-300">
                {{ description }}
            </span>
        </div>
    </div>
</template>

<script setup>
defineOptions({
    inheritAttrs: false
})

defineProps({
    description: {
        type: String,
        default: null
    },
    toolTip: {
        type: [Boolean, String],
        default: false,
        description: 'true == left || right || center'
    }
})
</script>